import './style.less';

export default function($log, AuthClass, $stateParams) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  vm.formData = {};

  vm.AuthClass = AuthClass;
  vm.message = false;

  vm.year = new Date().getFullYear();

  vm.$stateParams = $stateParams;

  if ($stateParams.email !== 'false' && $stateParams.temp !== 'false') {
    let email = decodeURI($stateParams.email);
    let password = decodeURI($stateParams.temp);
    AuthClass.login(email, password, function(err) {
      if (err) {
        vm.message = true;
        throw err;
      }
    });
  }

  vm.login = function() {
    AuthClass.login(vm.formData.email, vm.password, function(err) {
      if (err) {
        vm.message = true;
        throw err;
      }
    });
  };

  function activate() {
    $log.debug('User Login Page Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/login/index.js